import React from 'react';
import Modal from './workspace/Modal';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    listName: string | null;
    isDeleting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title?: string;
    message?: string;
    /** What else goes with it — only worth spelling out when the delete cascades. */
    details?: React.ReactNode;
}

/** The confirm step on every destructive action. Named for word lists; used for all of them. */
export const DeleteConfirmationModal = ({
  isOpen,
  listName,
  isDeleting,
  onConfirm,
  onCancel,
  title = 'Delete word list?',
  message = 'Are you sure you want to delete',
  details
}: DeleteConfirmationModalProps) => (
  <Modal
    isOpen={isOpen}
    title={title}
    onClose={isDeleting ? () => {} : onCancel}
    widthClass="max-w-md"
    footer={
      <>
        <button
          type="button"
          onClick={onCancel}
          disabled={isDeleting}
          className="rounded-lg px-3 py-1.5 text-sm text-gray-400 hover:bg-gray-800 hover:text-gray-100
           transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={isDeleting}
          className="rounded-lg bg-red-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-500
           transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
        >
          {isDeleting ? 'Deleting…' : 'Delete'}
        </button>
      </>
    }
  >
    <p className="text-sm text-gray-300">
      {message} “<span className="font-medium text-red-300">{listName}</span>”?
    </p>
    {details && <div className="mt-3 text-sm text-gray-400">{details}</div>}
    <p className="mt-2 text-xs text-gray-500">This action cannot be undone.</p>
  </Modal>
);
